import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { Menu } from '../menu.model';
import { AuthService } from '../../../../shared/services/auth.service';
import { UsersService } from '../../../../pages/users/users.service';
import { MessageService } from '../../../../message.service';
import { User } from '../../../../pages/users/user.model';
import { Observable } from 'rxjs';
import { GeneralService } from '../../../../shared/services/general.service';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService, UsersService, MessageService ]
})
export class VerticalMenuComponent implements OnInit {
  @Input('menuItems') menuItems;
  @Input('menuParentId') menuParentId;
  parentMenu: Array<any>;
  public settings: Settings;
  totalRejected$: Observable<Number>;
  user: User;
  @Input() stacatalu: string = '';

  constructor(public appSettings: AppSettings, public menuService: MenuService, public router: Router, private usersService: UsersService, private messageService: MessageService) {
    this.settings = this.appSettings.settings;

    this.user = AuthService.getUser();
    
    this.totalRejected$ = this.menuService.totalRejected$;

  }

  ngOnInit() {
    // this.messageService.onLoadedMenu.subscribe(x => {
    //   this.menuItems = MenuService.menuItems;
    //   this.parentMenu = this.menuItems.filter(this.checkMenuPermission);

    //   const professorPayment = this.parentMenu.find((item: Menu) => item.id == 30);
    //   if (professorPayment) {
    //     (professorPayment as Menu).name = AuthService.getUser().role.id == 2 ? 'Mis pagos' : 'Pagos de profesores';
    //   }

    //   console.log(this.parentMenu);
    // });

    if(MenuService.totalRejected == null){
      MenuService.totalRejected = 0;
      if(AuthService.isStudent()){
        this.menuService.LoadDocumentationNotifications(this.user.business.id, this.user.registration);
      }
    }

    if(!MenuService.menuItems) {
      this.menuService.getMenu().subscribe(items => {
        //console.log(items);
        MenuService.menuItems = items;
        if(MenuService.menuItems) {
          this.menuItems = MenuService.menuItems;
          this.parentMenu = this.menuItems.filter(this.checkMenuPermission);
    
          const professorPayment = this.parentMenu.find((item: Menu) => item.id == 30);
          if (professorPayment) {
            (professorPayment as Menu).name = AuthService.getUser().role.id == 2 ? 'Mis pagos' : 'Pagos de profesores';
          }
    
          this.user = AuthService.getUser();
          let newName = this.user.level_id == 2 ? 'Mi Certificado de Bachillerato' : (this.user.level_id == 3 ? 'Mi Título Profesional' : 'Mi Grado Academico');
          const myTitleRegister = this.parentMenu.find((item: Menu) => item.id == 194);
          if (myTitleRegister) {
            (myTitleRegister as Menu).name = newName;
          }
          //console.log(this.parentMenu);
          this.filterMenuByInstitution();
        }
      });
    }

    if(MenuService.menuItems) {
      this.menuItems = MenuService.menuItems;
      this.parentMenu = this.menuItems.filter(this.checkMenuPermission);

      const professorPayment = this.parentMenu.find((item: Menu) => item.id == 30);
      if (professorPayment) {
        (professorPayment as Menu).name = AuthService.getUser().role.id == 2 ? 'Mis pagos' : 'Pagos de profesores';
      }

      // Condicional para texto dinamico en Mi Titulo 

      this.user = AuthService.getUser();
      let newName = this.user.level_id == 2 ? 'Mi Certificado de Bachillerato' : (this.user.level_id == 3 ? 'Mi Título Profesional' : 'Mi Grado Academico');
      const myTitleRegister = this.parentMenu.find((item: Menu) => item.id == 194);
      if (myTitleRegister) {
        (myTitleRegister as Menu).name = newName;
      }
      this.filterMenuByInstitution();

      //console.log(this.parentMenu);
    }
// setTimeout(() => {
//     this.parentMenu = this.menuService.getVerticalMenuItems().filter(this.checkMenuPermission);

//     const professorPayment = this.menuService.getVerticalMenuItems().find((item: Menu) => item.id == 30);
//     // if (professorPayment) {
//       (professorPayment as Menu).name = AuthService.getUser().role.id == 2 ? 'Mis pagos' : 'Pagos de profesores';
//     // }

//     console.log(this.parentMenu);
// }, 2000);
    
  }

  // checkMenuPermission = (item: Menu) => {
  //   return (item.parentId === this.menuParentId && AuthService.getUser().rolePermissions.modules.indexOf(item.id) !== -1);
  // }

  checkMenuPermission = (item: Menu) => {
    return (item.parentId === this.menuParentId && AuthService.checkPermissions(item.id));
  }

  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(this.settings.fixedHeader){
          let mainContent = document.getElementById('main-content');
          if(mainContent){
            mainContent.scrollTop = 0;
          }
        }
        else{
          document.getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
        }
      }                
    });
  }

  onClick(menuId){
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);    
  }

  /**
   * Filters menu items based on user's institution exclusion rules
   * Removes menu items that should not be displayed for specific institutions
  */
  private filterMenuByInstitution() {
    const levelExclusionsModule = {
      4: [217]
    };

    const exclusionRules = {
      5: [148],    // inst_id 5 → exclude menu item with ID 148
    };

    // 1. Reglas por estatus (ejemplo: estatus 'B' de Baja no ve el ID 200)
    const statusExclusions = {
      'PR': [203],
    };

    // 2. Reglas por ID de alumno específico (Excepciones manuales)
    const studentExclusions = {
      
    };

    const idsToExclude = exclusionRules[this.user.inst_id] || [];
    const statusIds = statusExclusions[this.stacatalu] || [];
    const individualIds = studentExclusions[this.user.registration] || [];
    const levelIds = levelExclusionsModule[this.user.level_id] || [];


    // Combinamos todos los IDs que deben ser excluidos
    const allExcludedIds = [...statusIds, ...individualIds, ...idsToExclude, ...levelIds];

    this.parentMenu = this.parentMenu.filter(item => !allExcludedIds.includes(item.id));
  }
}
